import React, { useState, useCallback } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'lodash';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';
import InlineTimeSelect from '../inputs/InlineTimeSelect';
import RuleForm from '../inputs/RuleForm';
import InlineTimeOperator from '../inputs/InlineTimeOperator';


const OrderTimingRule = (props) => {
  const {
    initialValues,
    onSubmit: propSubmit,
    form,
    type,
    ...other
  } = props;

  const TimeOperator = { BEFORE: 'Before', AFTER: 'After' };
  const initialState = {
    time: initialValues.time || moment().format('HH:mm'),
    time_operator: initialValues.time_operator || TimeOperator.BEFORE,
    percentage: initialValues.percentage || '',
    supplier: initialValues.supplier || '',
    regions: !_.isEmpty(initialValues.regions) ? initialValues.regions : [0]
  };
  const [time, setTime] = useState(initialState.time);
  const [time_operator, setTimeOperator] = useState(initialState.time_operator);
  const [percentage, setPercentage] = useState(initialState.percentage);
  const [supplier, setSupplier] = useState(initialState.supplier);
  const [regions, setRegions] = useState(initialState.regions);

  const onSubmit = useCallback((event) => {
    event.preventDefault();
    propSubmit({
      kind: 'order_timing',
      regions: _.filter(regions),
      value: {
        time,
        time_operator,
        percentage,
        supplier
      }
    });
  }, [time, time_operator, percentage, supplier, regions, propSubmit]);

  const onReset = useCallback(() => {
    setTime(initialState.time);
    setTimeOperator(initialState.time_operator);
    setPercentage(initialState.percentage);
    setSupplier(initialState.supplier);
    setRegions(initialState.regions);
  }, [initialState]);

  return (
    <RuleForm
      {...other}
      onSubmit={onSubmit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        onChange={setRegions}
        value={regions}
      />
      <InlineSupplierSelect
        value={supplier}
        onChange={setSupplier}
        include_all={false}
        include_any={false}
        placeholder='Select Supplier...'
      />
      <InlineInputNumber
        label='Percentage'
        description='Percentage of Orders Threshold'
        displayFormat='percent'
        value={percentage}
        onChange={setPercentage}
      />
      <InlineTimeOperator
        operators={TimeOperator}
        value={time_operator}
        onChange={setTimeOperator}
      />
      <InlineTimeSelect
        description="The time that orders have to be placed before or after by with respect to a location's local time "
        timeFormat='HH:mm'
        value={time}
        onChange={setTime}
      />
    </RuleForm>
  );
};


OrderTimingRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

OrderTimingRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default OrderTimingRule;
